import i18next from 'i18next';
import GlobalUsersManagement from '../../../../../components/Users/List/GlobalUsersManagement';
import UserAccountsManagement from '../../../../../components/Users/Item/UserAccountsManagement';
import UserLogo from '../../../../../components/Shared/Icons/UserLogo';
import permissions from '../../../../permissions';

const USER_ROUTE_GLOBAL_MANAGEMENT = {
  path: '/:currentAccountUuid/global-users',
  exact: true,
  additional: {
    component: GlobalUsersManagement,
    protected: true,
    title: i18next.t('titles:globalUsersManagement'),
    icon: UserLogo,
    permission: permissions.ACCOUNT_USERS_GET,
  },
};

const USER_ROUTE_ACCOUNTS_MANAGEMENT = {
  path: '/:currentAccountUuid/users/:userUuid/manage-accounts',
  exact: true,
  parentRoute: USER_ROUTE_GLOBAL_MANAGEMENT,
  additional: {
    component: UserAccountsManagement,
    protected: true,
    title: i18next.t('titles:manageUserAccounts'),
    permission: permissions.ACCOUNT_USERS_GET,
  },
};

export const USER_ROUTES = {
  // ------- Global users management ------
  globalManagement: USER_ROUTE_GLOBAL_MANAGEMENT,
  accountsManagement: USER_ROUTE_ACCOUNTS_MANAGEMENT,
};
